// src/shared/components/layout/Avatar.jsx
import * as React from 'react';
import Avatar from '@mui/material/Avatar';

function stringToColor(string = 'User') {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

function initials(name = 'User') {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? 'U';
  return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
}

export default function UserAvatar({ name = 'User' }) {
  return (
    <Avatar sx={{ width: 30, height: 30, bgcolor: stringToColor(name) }}>
      {initials(name)}
    </Avatar>
  );
}
